// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileTabs-moduledivider__nFS4b Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
